<template>
  <div class="row pl-5">
    <div class="col">
      <div class="row pb-2 mt-4 mb-2 border-bottom">
        <h1 class>Events</h1>
      </div>
      <div class="row pb-2 mt-4 mb-2 border-bottom">
        <VerifyPhone></VerifyPhone>
        <DisplayEvents class="container-fluid"></DisplayEvents>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
</style>

<script>
import VerifyPhone from "./VerifyPhone.vue";
import DisplayEvents from "./DisplayEvents.vue";

export default {
  name: "events",
  components: { VerifyPhone, DisplayEvents },
  data() {
    return {};
  },
  methods: {}
};
</script>